import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "49bb2d62-0dfb-4c5e-bb63-7a7a742dbfb4", content: "frequency", options: {} },
  { id: "2ebae0df-f3f3-40f1-9da3-748a316aeaa6", content: "spectral distribution", options: {} },
  { id: "a3ae77f3-4ca7-4e92-927c-f22ac0e59514", content: "level", options: {} },
  { id: "655bd996-5eba-4614-a5ba-cd5f2f265dc2", content: "masking", options: {} },
  { id: "ad2ab96d-631c-4ce5-af42-a84794b2c0ba", content: "duration of sound", options: {} },
  { id: "8ff7f65d-85a6-48f4-ad98-70aec7bbd5a0", content: "temperature", options: {} },
];

export const task: Task = {
  id: "16b8b176-aabe-417d-abb5-7dc3bd3b146f",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "49bb2d62-0dfb-4c5e-bb63-7a7a742dbfb4",
    "2ebae0df-f3f3-40f1-9da3-748a316aeaa6",
    "a3ae77f3-4ca7-4e92-927c-f22ac0e59514",
    "655bd996-5eba-4614-a5ba-cd5f2f265dc2",
    "ad2ab96d-631c-4ce5-af42-a84794b2c0ba",
  ],
};
